import { render, staticRenderFns } from "./DepComponent.vue?vue&type=template&id=656f3140"
import script from "./DepComponent.vue?vue&type=script&lang=js"
export * from "./DepComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports